import {LeftColumn} from "../Components/Column";
import Page from "./Page";

function ContactPage() {
    return (
        <Page title="Contact" image={{
            image: "erika-radich-portrait.jpg",
            thumbAlt: "Erika Radich portrait",
            pixelWidth: 360,
            pixelHeight: 360
        }}>
            <LeftColumn>
                <p>Please contact me by whatever means you prefer if you would like to inquire about anything you
                    have seen
                    here.</p>

                <p>Erika Radich<br/>
                    57 Wildwood Road<br/>
                    Spofford, NH 03462<br/>
                    603-852-8753</p>

                <p><a href="mailto:erikaradich@icloud.com?subject=Web-Site-Contact" className="portFoot">Click
                    here</a> to
                    send me an email</p>


                <div className="portfolio-subtitle">Represented by:</div>

                <p>Represented by <a href="https://www.williamris.com/" className="portFoot" target="_blank" rel="noreferrer">William
                    Ris
                    Gallery</a>, Jamesport, NY</p>

                <p><a
                    href="https://www.mitchellgiddingsfinearts.com/index.php/artists/erika-radich.html#!WEB_Erika_Radich_Moon"
                    className="portFoot" target="_blank" rel="noreferrer">Mitchell Giddings Fine Arts</a>, Brattleboro, VT</p>

                <p><a href="https://www.zeamaysprintmaking.com/" className="portFoot" target="_blank" rel="noreferrer">Zeamays
                    Printmaking
                    Flat File Project</a></p>
            </LeftColumn>
        </Page>
    );
}

export default ContactPage;